import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-001acf30")

_pushScopeId("data-v-001acf30")
const _hoisted_1 = { class: "flex-center margin-top-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("保存 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_tag_input = _resolveComponent("tag-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      ref: "form",
      model: _ctx.formData,
      "label-width": "80px"
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          prop: "name",
          rules: [{ required: true,message: '请输入名称',trigger: 'blur' }],
          label: "名称"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "tags",
          label: "标签"
        }, {
          default: _withId(() => [
            _createVNode(_component_tag_input, {
              allowAddNewTag: false,
              modelValue: _ctx.formData.tags,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.tags = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "description",
          label: "说明"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.description = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        class: "margin-right-10",
        type: "primary",
        onClick: _ctx.onSubmit
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
        default: _withId(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ], 64))
})